module.exports = __webpack_public_path__ + "BrevCommUtil.exe";


//////////////////
// WEBPACK FOOTER
// ./node_modules/file-loader/dist/cjs.js?name=[name].[ext]!./src/client/res/files/BrevCommUtil.exe
// module id = 751
// module chunks = 0